/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Plan_DescriptionInputs */

const en_settings_overview_plan_description = /** @type {(inputs: Settings_Overview_Plan_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current subscription`)
};

const zh_settings_overview_plan_description = /** @type {(inputs: Settings_Overview_Plan_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前订阅`)
};

/**
* | output |
* | --- |
* | "Current subscription" |
*
* @param {Settings_Overview_Plan_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_overview_plan_description = /** @type {((inputs?: Settings_Overview_Plan_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Plan_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_overview_plan_description(inputs)
	return zh_settings_overview_plan_description(inputs)
});
export { settings_overview_plan_description as "settings.overview.plan_description" }